// Helpers puros para MassCampaignsPage (extraccion para reducir tamaño).
import * as XLSX from 'xlsx';
import { APP_NAME } from '@/lib/brand';

export const TEMPLATE_FIELD_SAMPLES = {
  name: ['Juan Perez', 'Maria Lopez', 'Carlos Diaz'],
  property: ['Depto Centro 201', 'Casa Polanco 14', 'Loft Roma Norte'],
  city: ['Ciudad de Mexico', 'Guadalajara', 'Monterrey'],
  price: ['$2,500,000', '$3,200,000', '$1,800,000'],
  date: ['2026-03-15', '2026-03-20', '2026-03-25'],
  phone: ['5512345678', '5598765432', '5511223344'],
  email: ['demo1@ejemplo.com', 'demo2@ejemplo.com', 'demo3@ejemplo.com'],
  agent: ['Laura Martinez', 'Ricardo Vega', 'Sofia Herrera'],
  company: ['Inmob MX', 'Grupo Atlas', 'RealState Plus'],
  stage: ['Nuevo', 'Contactado', 'Calificado'],
  generic: ['Valor ejemplo 1', 'Valor ejemplo 2', 'Valor ejemplo 3'],
};

export const dummyValueFor = (fieldName, idx) => {
  const key = String(fieldName || '').toLowerCase();
  if (/^\{\{\s*\d+\s*\}\}$/.test(key)) {
    return TEMPLATE_FIELD_SAMPLES.generic[idx % TEMPLATE_FIELD_SAMPLES.generic.length];
  }
  const bucket =
    /^(name|nombre|lead_name|full_name|first_name|contact)$/.test(key) ? 'name' :
    /property|propiedad|inmueble|desarrollo/.test(key) ? 'property' :
    /city|ciudad|location|ubicacion/.test(key) ? 'city' :
    /price|precio|monto|amount|valor/.test(key) ? 'price' :
    /date|fecha|appointment|cita/.test(key) ? 'date' :
    /phone|tel|whatsapp/.test(key) ? 'phone' :
    /email|correo|mail/.test(key) ? 'email' :
    /agent|agente|asesor|broker/.test(key) ? 'agent' :
    /company|empresa|brand|marca/.test(key) ? 'company' :
    /status|estado|stage|etapa/.test(key) ? 'stage' :
    'generic';
  const list = TEMPLATE_FIELD_SAMPLES[bucket];
  return list[idx % list.length];
};

export const BASE_COLUMN_ALIAS_SET = new Set([
  'telefono', 'phone', 'whatsapp', 'celular',
  'nombre', 'name',
  'email', 'correo', 'mail',
]);

export const buildDynamicColumns = (templateParams = []) => {
  const extras = [];
  const seen = new Set();
  const sorted = [...(templateParams || [])]
    .filter(p => p && typeof p.index === 'number')
    .sort((a, b) => a.index - b.index);
  for (const p of sorted) {
    if (p.type === 'field' && p.field_name) {
      const fn = String(p.field_name);
      if (!BASE_COLUMN_ALIAS_SET.has(fn.toLowerCase()) && !seen.has(fn)) {
        extras.push({ key: fn, kind: 'field' });
        seen.add(fn);
      }
    } else if (p.type === 'col_excel') {
      const key = `{{${p.index}}}`;
      if (!seen.has(key)) {
        extras.push({ key, kind: 'col_excel', index: p.index });
        seen.add(key);
      }
    }
  }
  return extras;
};

export const downloadCampaignTemplate = ({ templateName = '', templateParams = [] } = {}) => {
  const extras = buildDynamicColumns(templateParams);
  const header = ['telefono', 'nombre', 'email', ...extras.map(e => e.key)];

  const baseRows = [
    { telefono: '5512345678', nombre: 'Juan Perez', email: 'juan.perez@ejemplo.com' },
    { telefono: '5598765432', nombre: 'Maria Lopez', email: 'maria.lopez@ejemplo.com' },
    { telefono: '5511223344', nombre: 'Carlos Diaz', email: 'carlos.diaz@ejemplo.com' },
    { telefono: '3312345678', nombre: 'Ana Gomez', email: 'ana.gomez@ejemplo.com' },
    { telefono: '8112345678', nombre: 'Pedro Rojas', email: 'pedro.rojas@ejemplo.com' },
  ];
  const rowCount = extras.length > 0 ? 3 : 5;
  const rows = baseRows.slice(0, rowCount).map((r, idx) => {
    const row = { ...r };
    extras.forEach(e => { row[e.key] = dummyValueFor(e.key, idx); });
    return row;
  });

  const ws = XLSX.utils.json_to_sheet(rows, { header });
  for (let i = 2; i <= rows.length + 1; i += 1) {
    const cell = ws[`A${i}`];
    if (cell) cell.t = 's';
  }
  const noteRow = rows.length + 3;
  XLSX.utils.sheet_add_aoa(
    ws,
    [['El telefono puede ser de 10 digitos (ej: 5512345678). ' + APP_NAME + ' normaliza el formato automaticamente.']],
    { origin: `A${noteRow}` }
  );
  ws['!cols'] = [
    { wch: 18 }, { wch: 20 }, { wch: 28 },
    ...extras.map(() => ({ wch: 20 })),
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Contactos');
  const safe = String(templateName || '').trim().replace(/[^a-zA-Z0-9_-]/g, '_');
  const fileName = safe ? `plantilla_${safe}_leadcem.xlsx` : 'plantilla_campana_leadcem.xlsx';
  XLSX.writeFile(wb, fileName);
};

// Constantes de wizard/canales
export const CHANNEL_TO_PROVIDER = { waba: 'meta_cloud', cloud: 'meta_cloud', gupshup: 'gupshup', twilio: 'twilio', meta_cloud: 'meta_cloud' };
